(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-featured-carosel"] && !Shopify.designMode) return;
  try {
    
  // Carousel is handled by CSS animations for better performance
  // Hover pause is handled by CSS :hover pseudo-class

  } catch(e) { console.error(e); }
})();
})();
